import React from 'react';
import { ICustomerInvite, IInvite, IUserInvite } from '../../lib/types';
import InviteModal from '../invite-modal/invite-modal';
import './invite-button.scss';

export interface IInviteButtonProps {
   inviteTarget: string;
   headerText: string;
   bodyText: string;
   confirmText: string;
   successTextPre: string;
   successTextPost: string;
   affiliateId?: number;
   inviteFunction: (
      invite: IInvite
   ) => Promise<ICustomerInvite | null> | Promise<IUserInvite | null>;
}

export default function InviteButton(props: IInviteButtonProps): JSX.Element {
   const plusSvg = new URL('/public/images/plus.svg', import.meta.url);
   const [modalClass, setModalClass] = React.useState('modal-hidden');

   const showModal = (): void => {
      setModalClass('');
   };

   return (
      <div className="invite-button-wrapper">
         <button className="invite-button" onClick={() => showModal()}>
            <div className="invite-icon">
               <img src={plusSvg.toString()} />
            </div>

            <div className="body-standard-regular">
               {props.inviteTarget === 'Employee' ? `Add new ${props.inviteTarget}` : `Invite a New ${props.inviteTarget}`}
            </div>
         </button>
         <InviteModal
            inviteTarget={props.inviteTarget}
            headerText={props.headerText}
            bodyText={props.bodyText}
            confirmText={props.confirmText}
            successTextPre={props.successTextPre}
            successTextPost={props.successTextPost}
            modalClass={modalClass}
            setModalClass={setModalClass}
            submitFunction={props.inviteFunction}
            affiliateId={props.affiliateId}
         />
      </div>
   );
}
